import type { ContactForm } from '@/types';
import { SUPABASE_ANON_KEY, SUPABASE_FUNCTION_BASE_URL } from './config';

const SITE_CONTACT_ENDPOINT = `${SUPABASE_FUNCTION_BASE_URL}/site-contact`;

export async function sendContactForm(form: ContactForm): Promise<boolean> {
  try {
    const response = await fetch(SITE_CONTACT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY && {
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        }),
      },
      body: JSON.stringify(form),
    });

    if (!response.ok) {
      let message = `Request failed with status ${response.status}`;
      try {
        const errorBody = (await response.json()) as { error?: string };
        if (errorBody?.error) {
          message = errorBody.error;
        }
      } catch (parseError) {
        console.warn('Failed to parse error payload from contact function', parseError);
      }

      throw new Error(message);
    }

    return true;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Failed to send contact form');
  }
}
